import React, { useState, useEffect } from 'react';
import styles from '../../styles/RolesPermissionsStyles/RolesPermissions.module.css';
import { getInstituciones } from '../../api/roles';

function RoleForm({ role, onSave }) {
  const [instituciones, setInstituciones] = useState([]);
  const [formData, setFormData] = useState({
    nombre_rol: '',
    descripcion: '',
    id_institucion: '',
    ambito_visualizacion: 'INSTITUCION',
    nivel_acceso: 1
  });

  // Cargar instituciones al montar
  useEffect(() => {
    loadInstituciones();
  }, []);

  const loadInstituciones = async () => {
    try {
      const data = await getInstituciones();
      setInstituciones(data);
      
      // Si no hay institución seleccionada y hay instituciones, seleccionar la primera
      if (data.length > 0 && !formData.id_institucion) {
        setFormData(prev => ({
          ...prev,
          id_institucion: data[0].id_institucion
        }));
      }
    } catch (error) {
      console.error('Error al cargar instituciones:', error);
    }
  };

  // Actualizar form cuando cambia el rol seleccionado
  useEffect(() => {
    if (role) {
      setFormData({
        nombre_rol: role.nombre_rol || '',
        descripcion: role.descripcion || '',
        id_institucion: role.id_institucion?.id_institucion || role.id_institucion || '',
        ambito_visualizacion: role.ambito_visualizacion || 'INSTITUCION',
        nivel_acceso: role.nivel_acceso || 1
      });
    }
  }, [role]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    onSave(formData);
  };

  const handleCancel = () => {
    if (role) {
      setFormData({
        nombre_rol: role.nombre_rol || '',
        descripcion: role.descripcion || '',
        id_institucion: role.id_institucion?.id_institucion || role.id_institucion || '',
        ambito_visualizacion: role.ambito_visualizacion || 'INSTITUCION',
        nivel_acceso: role.nivel_acceso || 1
      });
    }
  };

  return (
    <div className={styles.roleFormContainer}>
      <div className={styles.roleFormHeader}>
        <div className={styles.roleNameDisplay}>
          <span className={styles.roleNameLabel}>Nombre del rol:</span>
          <span className={styles.roleNameValue}>{formData.nombre_rol}</span>
        </div>
      </div>
      
      <div className={styles.roleFormContent}>
        <div className={styles.formRow}>
          <div className={styles.formField}>
            <label className={styles.fieldLabel}>Descripción</label>
            <textarea
              className={styles.textArea}
              placeholder="Descripción del rol"
              value={formData.descripcion}
              onChange={(e) => handleInputChange('descripcion', e.target.value)}
              rows={3}
            />
          </div>
          
          <div className={styles.formField}>
            <label className={styles.fieldLabel}>Institución de aplicación</label>
            <select
              className={styles.selectField}
              value={formData.id_institucion}
              onChange={(e) => handleInputChange('id_institucion', parseInt(e.target.value))}
            >
              <option value="">Seleccione una institución</option>
              {instituciones.map(inst => (
                <option key={inst.id_institucion} value={inst.id_institucion}>
                  {inst.nombre_institucion}
                </option>
              ))}
            </select>
          </div>
          
          <div className={styles.formField}>
            <label className={styles.fieldLabel}>Ámbito de visualización</label>
            <select
              className={styles.selectField}
              value={formData.ambito_visualizacion}
              onChange={(e) => handleInputChange('ambito_visualizacion', e.target.value)}
            >
              <option value="INSTITUCION">Toda la institución</option>
              <option value="MULTI_CAMPUS">Múltiples campus</option>
              <option value="SOLO_CAMPUS">Solo campus</option>
            </select>
          </div>
        </div>
        
        <div className={styles.formActions}>
          <button className={styles.cancelButton} onClick={handleCancel}>
            CANCELAR
          </button>
          <button className={styles.saveButton} onClick={handleSave}>
            GUARDAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default RoleForm;
